// src/stores/mobileNavStore.ts
import { create } from 'zustand';

interface MobileNavState {
  title: string;
  showBack: boolean;
  setNavigation: (opts: { title: string; showBack?: boolean }) => void;
  reset: () => void;
}

export const useMobileNavStore = create<MobileNavState>((set) => ({
  title: 'QOps',
  showBack: false,
  setNavigation: ({ title, showBack = false }) => set({ title, showBack }),
  reset: () => set({ title: 'QOps', showBack: false }),
}));
